import styled from "styled-components";

const TidalCheckboxWrapper = styled.div<{
  isChecked: boolean;
}>`
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-gap: 0 8px;
  cursor: pointer;
  & > div {
    height: 16px;
    width: 16px;
    position: relative;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
    background-color: ${(props) => props.theme.colors.secondary};
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      height: 12px;
      width: 12px;
      border-radius: 4px;
      background-color: ${(props) => props.theme.colors.accent};
    }
  }
  & > p {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.colors.text[0]};
  }
`;

interface ITidalCheckbox {
  text: string;
  isChecked: boolean;
  onClick?: () => void;
}

const TidalCheckbox = ({
  text,
  isChecked,
  onClick,
}: ITidalCheckbox): JSX.Element => {
  return (
    <TidalCheckboxWrapper
      onClick={() => onClick && onClick()}
      isChecked={isChecked}
    >
      <div>{isChecked && <div></div>}</div>
      <p>{text}</p>
    </TidalCheckboxWrapper>
  );
};

export default TidalCheckbox;
